<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Masters</a>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/asset_templates">Asset Templates</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">New Asset Template</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Asset Template</li>
                </ol>
                <h4 class="main-title mb-0">Asset Template</h4>
            </div>
            <router-link to="/asset_templates" type="submit" class="btn btn-primary" style="float: right;"><i
                    class="ri-list-check"></i> ASSET TEMPLATES</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Asset Template</h6>
                            <h6 class="card-title" v-else>Update Asset Template</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-4">
                                    <label class="form-label">Asset Type</label><span class="text-danger"> *</span>
                                    <search :class="{ 'is-invalid': errors.asset_type_id }"
                                        :customClass="{ 'is-invalid': errors.asset_type_id }"
                                        :initialize="asset.asset_type_id" id="asset_type_id" label="asset_type_name"
                                        label2="asset_type_code" placeholder="Select Asset Type"
                                        :data="asset_parameters" @input="asset_type => asset.asset_type_id = asset_type"
                                        @selectsearch="getAssetType(asset.asset_type_id)">
                                    </search>

                                    <span v-if="errors.asset_type_id" class="invalid-feedback">{{
                                        errors.asset_type_id[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Template Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Enter Template Code" class="form-control"
                                        :class="{ 'is-invalid': errors.template_code }" v-model="asset.template_code" />
                                    <span v-if="errors.template_code" class="invalid-feedback">{{
                                        errors.template_code[0] }}</span>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Template Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Enter Template Name" class="form-control"
                                        :class="{ 'is-invalid': errors.template_name }" v-model="asset.template_name" />
                                    <span v-if="errors.template_name" class="invalid-feedback">{{
                                        errors.template_name[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Latitude</label>
                                    <input type="number" placeholder="Enter Latitude" class="form-control"
                                        :class="{ 'is-invalid': errors.latitude }" v-model="asset.latitude" />
                                    <span v-if="errors.latitude" class="invalid-feedback">{{ errors.latitude[0]
                                        }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Longitude</label>
                                    <input type="number" placeholder="Enter Longitude" class="form-control"
                                        :class="{ 'is-invalid': errors.longitude }" v-model="asset.longitude" />
                                    <span v-if="errors.longitude" class="invalid-feedback">{{ errors.longitude[0]
                                        }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Radius</label>
                                    <input type="number" placeholder="Enter Radius" class="form-control"
                                        :class="{ 'is-invalid': errors.radius }" v-model="asset.radius" />
                                    <span v-if="errors.radius" class="invalid-feedback">{{ errors.radius[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Department</label>
                                    <select class="form-control" :class="{ 'is-invalid': errors.department_id }"
                                        v-model="asset.department_id">
                                        <option value="">Select Department</option>
                                        <option v-for="department, key in departments" :key="key"
                                            :value="department?.department_id">{{ department?.department_name }}
                                        </option>
                                    </select>
                                    <span v-if="errors.department_id" class="invalid-feedback">{{
                                        errors.department_id[0] }}</span>
                                </div>

                                <div class="col-md-4">
                                    <label class="form-label">Section</label>
                                    <select class="form-control" :class="{ 'is-invalid': errors.section_id }"
                                        v-model="asset.section_id">
                                        <option value="">Select Section</option>
                                        <option v-for="section, key in sections" :key="key"
                                            :value="section?.section_id">{{ section?.section_name }}</option>
                                    </select>
                                    <span v-if="errors.section_id" class="invalid-feedback">{{ errors.section_id[0]
                                        }}</span>
                                </div>

                                <div class="col-md-4" v-for="field, key in asset.asset_parameters" :key="key">
                                    <div v-if="field.field_type == 'Text'">
                                        <label class="form-label">{{ field.field_name }}</label><span
                                            v-if="field.is_required" class="text-danger">*</span>
                                        <input type="text" class="form-control"
                                            :placeholder="'Enter ' + field.field_name"
                                            :class="{ 'is-invalid': errors[field.field_name] }"
                                            v-model="field.asset_parameter_value.field_value" />
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">{{
                                            errors[field.field_name][0] }}</span>
                                    </div>

                                    <div v-if="field.field_type == 'Number'">
                                        <label class="form-label">{{ field.field_name }}</label><span
                                            v-if="field.is_required" class="text-danger">*</span>
                                        <input type="text" class="form-control" min="0"
                                            oninput="validity.valid||(value='');"
                                            :placeholder="'Enter ' + field.field_name"
                                            :class="{ 'is-invalid': errors[field.field_name] }"
                                            v-model="field.asset_parameter_value.field_value" />
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">{{
                                            errors[field.field_name][0] }}</span>
                                    </div>

                                    <div v-if="field.field_type === 'Date'">
                                        <label class="form-label">
                                            {{ field.field_name }}
                                            <span v-if="field.is_required" class="text-danger">*</span>
                                        </label>
                                        <input type="date" class="form-control"
                                            :placeholder="'Enter ' + field.field_name"
                                            :class="{ 'is-invalid': errors[field.field_name] }"
                                            v-model="field.asset_parameter_value.field_value" />
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">
                                            {{ errors[field.field_name][0] }}
                                        </span>
                                    </div>

                                    <div v-if="field.field_type === 'Date&Time'">
                                        <label class="form-label">
                                            {{ field.field_name }}
                                            <span v-if="field.is_required" class="text-danger">*</span>
                                        </label>
                                        <input type="datetime-local" class="form-control"
                                            :placeholder="'Enter ' + field.field_name"
                                            :class="{ 'is-invalid': errors[field.field_name] }"
                                            v-model="field.asset_parameter_value.field_value" step="1" />
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">
                                            {{ errors[field.field_name][0] }}
                                        </span>
                                    </div>
                                    <div v-if="field.field_type == 'Dropdown'">
                                        <label class="form-label">{{ field.field_name }}</label><span
                                            v-if="field.is_required" class="text-danger">*</span>
                                        <select class="form-control" :class="{ 'is-invalid': errors[field.field_name] }"
                                            v-model="field.asset_parameter_value.field_value">
                                            <option :value="field.asset_parameter_value.field_value"
                                                v-if="field.asset_parameter_value.field_value"> {{
                                                    field.asset_parameter_value.field_value }}</option>
                                            <option :value="field.asset_parameter_value.field_value" v-else>Select {{
                                                field.display_name }}</option>
                                            <option
                                                v-for="(value, key) in (field.field_values ? field.field_values.split(',') : [])"
                                                :key="key" :value="value">{{ value }}</option>
                                        </select>
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">{{
                                            errors[field.field_name][0] }}</span>
                                    </div>
                                    <div v-if="field.field_type == 'List'">
                                        <label class="form-label">{{ field.display_name }}</label><span
                                            v-if="field.is_required" class="text-danger">*</span>
                                        <select class="form-control"
                                            :class="{ 'is-invalid': errors[field.display_name] }"
                                            v-model="field.asset_parameter_value.field_value">
                                            <option :value="field.asset_parameter_value?.field_value"
                                                v-if="field.asset_parameter_value?.field_value">
                                                {{ field.asset_parameter_value?.field_value }}
                                            </option>
                                            <option :value="field.asset_parameter_value?.field_value" v-else>Select
                                                {{ field.display_name }}</option>
                                            <option v-for="value, key in field.list_parameter?.field_values.split(',')"
                                                :key="key" :value="value.trim()">{{ value.trim() }}</option>
                                        </select>
                                        <span v-if="errors[field.display_name]" class="invalid-feedback">{{
                                            errors[field.display_name][0] }}</span>
                                    </div>

                                    <div v-if="field.field_type == 'Color'">
                                        <label class="form-label">{{ field.display_name }}<span v-if="field.is_required"
                                                class="text-danger">*</span></label>
                                        <input type="color" class="form-control"
                                            v-model="field.asset_parameter_value.field_value" style="height: 2.2rem;" />
                                        <span v-if="errors[field.field_name]" class="invalid-feedback">{{
                                            errors[field.field_name][0] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <router-link type="button" to="/asset_templates" class="btn btn-danger me-2"><i
                                    class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                            <button type="submit" class="btn btn-primary">
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
export default {
    name: "AssetTemplates.Create",
    components: { Search },
    data() {
        return {
            asset: {
                asset_template_id: "",
                plant_id: "",
                template_code: "",
                template_name: "",
                asset_type_id: "",
                latitude: "",
                longitude: "",
                status: "",
                asset_parameters: [
                    //    {
                    //     field_name: 'Color Field',
                    //     field_type: 'Color',
                    //     asset_parameter_value: {
                    //         field_value: '#000000' // Default to black color
                    //     },
                    //     is_required: false // or true, based on your requirement
                    // }
                ],
                department_id: '',
                section_id: '',
                radius: '',
                deleted_asset_parameter_values: [],
            },
            voltage: {
                color: "#ffffff",
                voltage_code: "",
            },

            device_code: "",
            asset_parameters: [],
            deleted_asset_parameter_values: [],
            departments: [],
            sections: [],
            plants: [],
            asset_types: [],
            errors: [],
            status: true,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.asset.asset_parameters = []
            vm.getAssetsDropdown();
            if (to.name == "AssetTemplates.Create") {
                // vm.$refs.template_code.focus();
            } else {
                vm.status = false;
                let uri = { uri: "getAssetTemplate", data: { asset_template_id: to.params.asset_template_id } };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.asset = response.data.data;
                        vm.asset.asset_parameters.map(function (element) {
                            vm.deleted_asset_parameter_values.push(element.asset_parameter_value.template_parameter_value_id);
                        });
                        vm.asset.deleted_asset_parameter_values = [];
                    })
                    .catch(function (error) {
                        console.log(error)
                        // vm.errors = error.response.data.errors;
                        // vm.$store.dispatch("error", error.response.data.message);
                    });
            }
        });
    },
    computed: {
        selectedColorDisplay() {
            return this.selectedColorName ? `${this.selectedColorName} (${this.selectedColor})` : 'Select Color';
        },
        getComponentCode() {
            this.device_code = [this.voltage.voltage_code, this.watt_rating, this.frame, this.mounting, this.section, this.make, this.speed, this.asset.serial_no];
            return this.device_code.join("");
            // if(this.voltage.voltage_code[0]){
            //     return this.device_code.join('');
            // }else{
            //     return this.device_code.join('-');
            // }
        },
    },
    methods: {
        selectColor(colorValue, colorName, field) {
            this.selectedColor = colorValue;
            this.selectedColorName = colorName;
            this.dropdownVisible = false;
            field.field_value = colorValue;
            this.updateAssetParameters(field);
        },
        toggleDropdown() {
            this.dropdownVisible = !this.dropdownVisible;
        },
        updateAssetParameters(field) {
            console.log(field)
            let apid = this.asset.asset_parameters.filter(function (element) {
                return element.asset_parameter_id == field.asset_parameter_id
            })
            if (!apid.length) {
                this.asset.asset_parameters.push({
                    'asset_parameter_id': field.asset_parameter_id,
                    'field_value': field.field_value
                })
            }
        },
        submitForm() {
            let vm = this;
            if (vm.status) {
                vm.addAsset();
            } else {
                vm.updateAsset();
            }
        },
        getAssetsDropdown() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "getAssetTypes" })
                .then((response) => {
                    loader.hide();
                    vm.asset_parameters = response.data.data;
                    vm.getDepartments();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        getDepartments() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch('post', { uri: 'getDepartments' })
                .then(response => {
                    loader.hide();
                    vm.departments = response.data.data;
                    vm.getSections();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        getSections() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch('post', { uri: 'getSections' })
                .then(response => {
                    loader.hide();
                    vm.sections = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        validateFields() {
            let isValid = true;
            this.errors = {};

            if (!this.asset.template_code) {
                this.errors.template_code = ["Template Code is required"];
                isValid = false;
            }
            if (!this.asset.template_name) {
                this.errors.template_name = ["Template Name is required"];
                isValid = false;
            }
            if (!this.asset.asset_type_id) {
                this.errors.asset_type_id = ["Asset Type is required"];
                isValid = false;
            }
            // if (this.asset.asset_type.length === 0) {
            //     this.errors.asset_types = ["At least one Asset Type must be selected"];
            //     isValid = false;
            // }
            // for (const field of Object.values(this.asset.asset_parameters)) {
            //     if (field.is_required && !field.asset_parameter_value.field_value) {
            //         this.errors[field.display_name] = [`${field.display_name} is required`];
            //         isValid = false;
            //     }
            // }

            for (const field of Object.values(this.asset.asset_parameters)) {
                if (field.is_required && !field.asset_parameter_value.field_value) {
                    if (field.field_type === 'Color') {
                        // Set default color if not provided
                        field.asset_parameter_value.field_value = '#000000'; // Default to black
                    } else {
                        this.errors[field.display_name] = [`${field.display_name} is required`];
                        isValid = false;
                    }
                }
            }
            console.log('Validation Errors:', this.errors);
            return isValid;
        },

        addAsset() {
            if (!this.validateFields()) {
                return;
            }
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "addAssetTemplate", data: vm.asset })
                .then((response) => {
                    loader.hide();
                    vm.$store.dispatch("success", response.data.message);
                    vm.$router.push("/asset_templates");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        updateAsset() {
            if (!this.validateFields()) {
                return;
            }
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "updateAssetTemplate", data: vm.asset })
                .then((response) => {
                    loader.hide();
                    vm.$store.dispatch("success", response.data.message);
                    vm.$router.push("/asset_templates");
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        getAsset() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("post", { uri: "getAsset", data: vm.asset })
                .then((response) => {
                    loader.hide();
                    vm.asset = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        discard() {
            let vm = this;
            vm.asset = {};
            // vm.$refs.template_name.focus();
            vm.errors = [];
            vm.voltage.color = "#ffffff";
            vm.voltage.voltage_code = "";
            vm.asset.serial_no = "";
            vm.watt_rating = "";
            vm.frame = "";
            vm.device_code = "";
            vm.mounting = "";
            vm.section = "";
            vm.make = "";
            vm.speed = "";
        },

        getAssetType(asset_type_id) {
            let vm = this;
            let loader = vm.$loading.show();
            if (vm.deleted_asset_parameter_values.length) {
                vm.asset.deleted_asset_parameter_values = vm.deleted_asset_parameter_values;
            }
            vm.$store
                .dispatch("post", { uri: "getAssetsDropdown", data: { asset_type_id: asset_type_id } })
                .then((response) => {
                    loader.hide();
                    console.log("rrr----", response.data)
                    vm.asset_types = response.data.data;
                    vm.asset.asset_parameters = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        }
    },
};
</script>

<style>
.color-square {
    width: 16px;
    height: 16px;
    display: inline-block;
    border: 1px solid #000;
}

.input-group {
    position: relative;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-menu.show {
    display: block;
}
</style>